import React from "react"
import * as Sentry from "@sentry/react"
import { IonButton, IonContent, IonPage, IonText } from "@ionic/react"

type ErrorBoundaryState = {
  hasError: boolean
}

class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Megio na pagina de errore che un bianco funerale.
    console.error("Unhandled UI error", error, info)
    Sentry.captureException(error, {
      contexts: {
        react: {
          componentStack: info.componentStack,
        },
      },
    })
  }

  private reloadApp = () => {
    window.location.reload()
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children
    }

    return (
      <IonPage>
        <IonContent className="ion-padding">
          <h1>Qualcosa è andato storto</h1>
          <IonText color="medium">
            L'app ha ricevuto un errore inatteso, ma non si è bloccata su schermata bianca.
          </IonText>
          <div className="ion-margin-top">
            <IonButton onClick={this.reloadApp}>Ricarica app</IonButton>
          </div>
        </IonContent>
      </IonPage>
    )
  }
}

export default ErrorBoundary
